import React, { useState } from "react";
import SlidingIconButton from "./SlidingIconButton"; // Ensure this component is converted to React
import { useStore } from "../../store/store"; // Adjust the import path as needed
import { useLocation } from "wouter";
import SearchField from "../SearchField";

const SearchButton: React.FC = () => {
  const { setArtworkInFront, isTourOpen } = useStore();
  const [searchFieldVisible, setSearchFieldVisible] = useState(false);
  const [, setLocation] = useLocation();

  const onClick = () => {
    setArtworkInFront(true);
    setSearchFieldVisible(true);
  };

  const hideSearchField = () => {
    setSearchFieldVisible(false);
  };

  const selectedItem = (selection: {
    name: string;
    type: string;
    uuid: string;
  }) => {
    setSearchFieldVisible(false);
    // Navigate to /search with query parameters
    const { name, type, uuid } = selection;
    const queryParams = new URLSearchParams({ name, type, uuid }).toString();
    setLocation(`/search?${queryParams}`);
  };

  return (
    <div className="relative z-40">
      <SlidingIconButton
        color="text-white"
        text="Zoeken"
        iconClass="d-search"
        disabled={isTourOpen}
        className={`button-search hover:w-[6.1rem] hover:border-seafoamGreen`}
        onClick={onClick}
        openByDefault={false}
        reverse={false}
      />
      {searchFieldVisible && (
        <SearchField onClose={hideSearchField} onSelected={selectedItem} />
      )}
    </div>
  );
};

export default SearchButton;
